import { Literal, Object, Runtype, Static, String, Union, Unknown } from 'runtypes';

const RouteMethodRecord = Union(Literal('get'), Literal('post'), Literal('put'), Literal('patch'), Literal('delete'));
export type RouteMethod = Static<typeof RouteMethodRecord>;

export interface Route<Req extends Runtype.Core = Runtype.Core, Res extends Runtype.Core = Runtype.Core> {
  method: RouteMethod;
  path: string;
  requestBody: Req;
  responseData: Res;
}

// BvdS:  I couldn't figure out how to generate this
const RuntypeCoreRecord = Unknown;

export const RouteRecord = Object({
  method: RouteMethodRecord,
  path: String,
  requestBody: RuntypeCoreRecord,
  responseData: RuntypeCoreRecord,
});
